import { StyleSheet } from 'aphrodite';
import {
	brandPrimaryHover,
	brandSecondaryHover,
	destructive,
	header,
	success,
	titles,
	warningDark,
} from '../../../../styles/colors';
import { CssSelectors, baseStyleSheet } from '../../../../styles/styles';

export const styleSheet = StyleSheet.create({
	blue: {
		color: brandSecondaryHover,
	},
	container: {
		color: header,
		fontSize: 12,
		...CssSelectors.allChildren(
			{
				marginTop: 6,
			},
			':not(:first-child)'
		),
	},
	date: {
		color: titles,
	},
	detailed: {
		color: brandPrimaryHover,
		width: 130,
	},
	expirationDate: {
		color: brandPrimaryHover,
	},
	expirationDateContainer: {
		display: 'flex',
		marginTop: 10,
	},
	expirationDateIcon: {
		display: 'inline-block',
		marginRight: 4,
	},
	green: {
		color: success,
	},
	icon: {
		marginRight: 4,
	},
	orange: {
		color: warningDark,
	},
	popoverContent: {
		borderRadius: 3,
		color: titles,
		fontSize: 12,
		padding: 16,
		width: 210,
	},
	reconnect: {
		color: destructive,
	},
	red: {
		color: destructive,
	},
	sendNowButton: {
		marginTop: 10,
	},
	status: {
		...baseStyleSheet.fontBold,
		textTransform: 'uppercase',
	},
});
